import {
  GameState,
  MultiplierValueDesktop,
  MultiplierValueTablet,
} from "../types/enums";

// 🎰 Desktop slot konfiguracija
export const mockMultiplierSlotsDesktop = [
  { value: MultiplierValueDesktop.FIVE_FS, color: "#fd8917" },
  { value: MultiplierValueDesktop.THREE_FS, color: "#fee767" },
  { value: MultiplierValueDesktop.TWO_FS, color: "#bcfe67" },
  { value: MultiplierValueDesktop.ONE_FS, color: "#68fec7" },
  { value: MultiplierValueDesktop.ZERO_FS, color: "#68f5fd" },
  { value: MultiplierValueDesktop.ZERO_FS, color: "#68f5fd" },
  { value: MultiplierValueDesktop.ONE_FS, color: "#68fec7" },
  { value: MultiplierValueDesktop.TWO_FS, color: "#bcfe67" },
  { value: MultiplierValueDesktop.THREE_FS, color: "#fee767" },
  { value: MultiplierValueDesktop.FIVE_FS, color: "#fd8917" },
];

// 📱 Tablet slot konfiguracija
export const mockMultiplierSlotsTablet = [
  { value: MultiplierValueTablet.FIVE_FS, color: "#fd8917" },
  { value: MultiplierValueTablet.THREE_FS, color: "#fee767" },
  { value: MultiplierValueTablet.TWO_FS, color: "#bcfe67" },
  { value: MultiplierValueTablet.ONE_FS, color: "#68fec7" },
  { value: MultiplierValueTablet.ZERO_FS, color: "#68f5fd" },
  { value: MultiplierValueTablet.ZERO_FS, color: "#68f5fd" },
  { value: MultiplierValueTablet.ONE_FS, color: "#68fec7" },
  { value: MultiplierValueTablet.TWO_FS, color: "#bcfe67" },
  { value: MultiplierValueTablet.THREE_FS, color: "#fee767" },
  { value: MultiplierValueTablet.FIVE_FS, color: "#fd8917" },
];

// 🪙 Početno stanje igre
export const mockRootProps = {
  initialCoins: 3,
  gameState: GameState.IDLE as const,
  backgroundImage: "/bg-underwater.png" as const,
  whaleMascotImage: "/whale-mascot.png" as const,
  titleImage: "my-app/public/whalex-plink-title.png" as const,
  bubbleImage: "/bubble.png" as const,
  coinImage: "/coin-gold.png" as const,
};
